var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import qs from "querystringify";
import { createBrowserHistory, createMemoryHistory, } from "history";
import { observable, action } from "mobx";
export class RouterStore {
    s;
    is404 = false;
    history;
    unlisten;
    onChange;
    constructor(initialState, onChange) {
        this.onChange = onChange;
        this.history = typeof window !== "undefined" ?
            createBrowserHistory() :
            createMemoryHistory();
        this.unlisten = this.history.listen(this.listen);
        this.s = observable({
            path: this.history.location.pathname,
            search: this.history.location.search,
            hash: this.history.location.hash,
            query: qs.parse(this.history.location.search),
            ...(initialState || {}),
        });
    }
    getOrigin = () => {
        let origin = window.location.origin;
        if (!origin) {
            origin = window.location.protocol + "//"
                + window.location.hostname
                + (window.location.port ? ":" + window.location.port : "");
        }
        return origin;
    };
    set404 = (is404) => this.is404 = is404;
    update = (data) => {
        this.s = { ...this.s, ...data };
    };
    push = (path) => {
        this.history.push(path);
    };
    listen = (location) => {
        this.s = {
            path: location.pathname,
            search: location.search,
            hash: location.hash,
            query: qs.parse(location.search),
        };
        if (this.onChange) {
            this.onChange(this.s);
        }
    };
}
__decorate([
    observable
], RouterStore.prototype, "s", void 0);
__decorate([
    observable
], RouterStore.prototype, "is404", void 0);
__decorate([
    action
], RouterStore.prototype, "set404", void 0);
__decorate([
    action
], RouterStore.prototype, "update", void 0);
__decorate([
    action
], RouterStore.prototype, "push", void 0);
__decorate([
    action
], RouterStore.prototype, "listen", void 0);
//# sourceMappingURL=store.js.map